import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';

import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import ChevronDoubleRightIcon from 'mdi-react/ChevronDoubleRightIcon';

import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import ChevronDoubleLeftIcon from 'mdi-react/ChevronDoubleLeftIcon';

export default class CustomPagination extends React.Component {
  static propTypes = {
    onChangePage: PropTypes.func.isRequired,
    itemsCount: PropTypes.number.isRequired,
    itemsToShow: PropTypes.number.isRequired,
    pageOfItems: PropTypes.number.isRequired,
  };

  setPage = (page) => {
    const { itemsCount, itemsToShow, onChangePage } = this.props;

    // calculate total pages
    const totalPages = Math.ceil(itemsCount / itemsToShow);

    if (page < 1 || page > totalPages) {
      return;
    }

    // call change page function in parent component
    onChangePage(page);
  };

  render4Pages = () => {
    const { itemsCount, itemsToShow, pageOfItems } = this.props;

    const pagesToShow = 4;
    const pages = [];
    const totalPages = Math.ceil(itemsCount / itemsToShow);

    if (totalPages <= pagesToShow) {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else {
      // 1 ... 5 6 7 .... 20 Paginantion impl
      pages.push(1);
      const currentPageSpace = pagesToShow === 1 || pagesToShow === totalPages ? 0 : 1;
      const dinamicPages = pagesToShow - 2 - currentPageSpace; // First, current and last
      if (totalPages / 2 < pageOfItems) {
        const to = Math.min(pageOfItems + Math.ceil(dinamicPages / 2), totalPages - 1);
        const from = Math.max(pageOfItems - (dinamicPages - (to - pageOfItems)), 2);
        if (from > 2) pages.push(0); // Separator
        for (let i = from; i <= to; i += 1) {
          pages.push(i);
        }
        if (to < (totalPages - 1)) pages.push(0); // Separator
      } else {
        const from = Math.max(pageOfItems - Math.floor(dinamicPages / 2), 2);
        const to = Math.min(pageOfItems + (dinamicPages - (pageOfItems - from)), totalPages - 1);
        if (from > 2) pages.push(0); // Separator
        for (let i = from; i <= to; i += 1) {
          pages.push(i);
        }
        if (to < (totalPages - 1)) pages.push(0); // Separator
      }
      pages.push(totalPages);
    }

    return itemsCount ? (
      <div className="pagination__wrap pages-4">
        {(itemsCount <= 1) ? ''
          : (
            <Pagination className="pagination" dir="ltr">
              <PaginationItem className="pagination__item" disabled={pageOfItems === 1}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(1)}
                >
                  <ChevronDoubleLeftIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem className="pagination__item" disabled={pageOfItems === 1}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(pageOfItems - 1)}
                >
                  <ChevronLeftIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              {pages.map(page => (
                page > 0
                  ? (
                    <PaginationItem
                      className="pagination__item"
                      key={page}
                      active={pageOfItems === page}
                    >
                      <PaginationLink
                        className="pagination__link"
                        type="button"
                        onClick={() => this.setPage(page)}
                      >
                        {page}
                      </PaginationLink>
                    </PaginationItem>
                  )
                  : (
                    <PaginationItem
                      className="pagination__item"
                      key={page}
                      active={pageOfItems === page}
                    >
                      <PaginationLink
                        className="pagination__link"
                        type="button"
                      >
                        ...
                      </PaginationLink>
                    </PaginationItem>
                  )
              ))
              }
              <PaginationItem className="pagination__item" disabled={itemsToShow * pageOfItems > itemsCount}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(pageOfItems + 1)}
                >
                  <ChevronRightIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem className="pagination__item" disabled={itemsToShow * pageOfItems > itemsCount}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(Math.ceil(itemsCount / itemsToShow))}
                >
                  <ChevronDoubleRightIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          )
        }
        <div className="pagination-info">
          <span>
            Resultado {`${(itemsToShow * (pageOfItems - 1)) + 1} - `}
            {
              itemsToShow * pageOfItems > itemsCount ? itemsCount : itemsToShow * pageOfItems
            }
            {` de ${itemsCount} registros`}
          </span>
        </div>
      </div>
    ) : <div />;
  }

  render9Pages = () => {
    const { itemsCount, itemsToShow, pageOfItems } = this.props;

    const pagesToShow = 4;
    const pages = [];
    const totalPages = Math.ceil(itemsCount / itemsToShow);

    if (totalPages <= pagesToShow) {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else {
      // 1 ... 5 6 7 .... 20 Paginantion impl
      pages.push(1);
      const currentPageSpace = pagesToShow === 1 || pagesToShow === totalPages ? 0 : 1;
      const dinamicPages = pagesToShow - 2 - currentPageSpace; // First, current and last
      if (totalPages / 2 < pageOfItems) {
        const to = Math.min(pageOfItems + Math.ceil(dinamicPages / 2), totalPages - 1);
        const from = Math.max(pageOfItems - (dinamicPages - (to - pageOfItems)), 2);
        if (from > 2) pages.push(0); // Separator
        for (let i = from; i <= to; i += 1) {
          pages.push(i);
        }
        if (to < (totalPages - 1)) pages.push(0); // Separator
      } else {
        const from = Math.max(pageOfItems - Math.floor(dinamicPages / 2), 2);
        const to = Math.min(pageOfItems + (dinamicPages - (pageOfItems - from)), totalPages - 1);
        if (from > 2) pages.push(0); // Separator
        for (let i = from; i <= to; i += 1) {
          pages.push(i);
        }
        if (to < (totalPages - 1)) pages.push(0); // Separator
      }
      pages.push(totalPages);
    }

    return itemsCount ? (
      <div className="pagination__wrap pages-9">
        {(itemsCount <= 1) ? ''
          : (
            <Pagination className="pagination" dir="ltr">
              <PaginationItem className="pagination__item" disabled={pageOfItems === 1}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(1)}
                >
                  <ChevronDoubleLeftIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem className="pagination__item" disabled={pageOfItems === 1}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(pageOfItems - 1)}
                >
                  <ChevronLeftIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              {pages.map(page => (
                page > 0
                  ? (
                    <PaginationItem
                      className="pagination__item"
                      key={page}
                      active={pageOfItems === page}
                    >
                      <PaginationLink
                        className="pagination__link"
                        type="button"
                        onClick={() => this.setPage(page)}
                      >
                        {page}
                      </PaginationLink>
                    </PaginationItem>
                  )
                  : (
                    <PaginationItem
                      className="pagination__item"
                      key={page}
                      active={pageOfItems === page}
                    >
                      <PaginationLink
                        className="pagination__link"
                        type="button"
                      >
                        ...
                      </PaginationLink>
                    </PaginationItem>
                  )
              ))
              }
              <PaginationItem className="pagination__item" disabled={itemsToShow * pageOfItems > itemsCount}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(pageOfItems + 1)}
                >
                  <ChevronRightIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem className="pagination__item" disabled={itemsToShow * pageOfItems > itemsCount}>
                <PaginationLink
                  className="pagination__link pagination__link--arrow"
                  type="button"
                  onClick={() => this.setPage(Math.ceil(itemsCount / itemsToShow))}
                >
                  <ChevronDoubleRightIcon className="pagination__link-icon" />
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          )
        }
        <div className="pagination-info">
          <span>
            Resultado {`${(itemsToShow * (pageOfItems - 1)) + 1} - `}
            {
              itemsToShow * pageOfItems > itemsCount ? itemsCount : itemsToShow * pageOfItems
            }
            {` de ${itemsCount} registros`}
          </span>
        </div>
      </div>
    ) : <div />;
  }

  render() {
    return (
      <>
        {this.render4Pages()}
        {this.render9Pages()}
      </>
    );
  }
}
